export interface IPage {
	name: string,
	id: string,
	content: string,
	open: boolean
}

export interface IConfig {
	minimenu: boolean
	portletId: string
}

export interface IState {
	pages: IPage[],
	config: IConfig
}

const deafultState: IState = {
	pages: [],
	config: {
		minimenu: false,
		portletId: ''
	}
}

export default deafultState;
